import { clone, IUpgradeState, IdHelper, IJourneyItem, IAdminToolPanel, IJESettingsSidebar, JESettingsListData } from '../../helpers/';
import { DEFAULT_JOURNEY_ID } from '../../constants';
import types from '../types';

const initialState: IUpgradeState = {
	pageMode: "alljourneys",
	tab: "Upgrade",
	processList: { "Upgrade": [], "Export": [], "Import": [], "Rollback": [], "JE Settings": [] },
	isProccessing: false,
	journeyProcessingId: '',
	journeyProcessNum: 0,
	isUpgradingScreen: false,
	UpgradeId: IdHelper.newGuid(),
	loggingList: [],
	cancelUpgrade: false,
	adminToolVersion: "",
	advancedLogging: false,
	panels: [],
	sidebar: { "isOpen": false, "type": "new", "jesetting": null, isSuccess: false, formValidationError: [], error: null },
	jesettingPropertyKey: '',
	jesettingPropertyValue: '',
	sidebarIsSuccess: false,
	sidebarFormValidationError: [],
	sidebarError: null,
	jesetting: null;
}

const adminToolReducer = function (state: IUpgradeState = initialState, action) {
	let stateClone: IUpgradeState = clone(state);

	switch (action.type) {
		case types.TOOL_SET_TAB:
			setTabMode(stateClone, action.tab)
		case types.SET_PAGE_MODE:
			setPageMode(stateClone, action.mode)
			break;
		case types.UPDATE_PROCESS_LIST:
			addProcessList(stateClone, action.item);
			break;
		case types.UPDATE_PROCESS_ITEM:
			updateProcessItemStatus(stateClone, action.key, action.status);
			break;
		case types.REMOVE_PROCESS_LIST:
			removeProcessList(stateClone, action.item);
			break;
		case types.CLEAR_DOWN_PROCESS_UPGRADE_STATE:
			clearDownProcessListState(stateClone);
			break;
		case types.SET_UPGRADE_CANCEL:
			cancelUpgrade(stateClone, action.cancelUpgrade);
			break;
		case types.CLEAR_DOWN_UPGRADE_STATE:
			clearDownState(stateClone);
			break;
		case types.UPDATE_ISPROCESSING_STATE:
			updateIsProcessingState(stateClone, action.IsProccessing, action.JourneyProcessingId, action.journeyProcessNum, action.isUpgradingScreen);
			break;
		case types.SET_PROCESSING_LOGGING:
			updateloggingList(stateClone, action.loggingList);
			break;
		case types.ADD_OR_UPDATE_PANEL:
			addOrUpdatePanel(stateClone, action.panel)
			break;
		case types.ADD_PANEL_ERRORMESSAGE:
			addOrUpdatePanelErrorMessage(stateClone, action.panelName, action.errorMessage)
			break;
		case types.CLEAR_PANEL_ERRORMESSAGES:
			clearPanelErrorMessages(stateClone, action.panelName)
			break;
		case types.SET_PANEL_LOADING:
			setPanelLoading(stateClone, action.panelName, action.isLoading)
			break;
		case types.ADD_OR_UPDATE_PANEL_VALUE:
			setPanelValue(stateClone, action.panelName, action.valueKey, action.value)
			break;
		case types.SET_SEARCH_FILTERS:
			setSearchFilters(stateClone, action.panelName, action.word)
			break;
		case types.SET_PAGING_NUMBER:
			setPagingNumber(stateClone, action.panelName, action.pagingNumber)
			break;
		case types.SET_UPGRADE_SETTINGS:
			setUpgradeSettings(stateClone, action.version, action.advancedLogging)
			break;
		case types.SET_JESETTINGS_SIDEBAR:
			setJESettingsSidebar(stateClone, action.sidebar)
			break;
		case types.SET_JESETTINGS_SIDEBAR_PROPERTY:
			setJESettingsSidebarProperty(stateClone, action.jesettingPropertyKey, action.jesettingPropertyValue)
			break;
		case types.SET_JESETTINGS_SIDEBAR_JESETTING:
			setJESettingsSidebarJESetting(stateClone, action.jesettingPropertyValue)
			break;
		case types.SET_JESETTINGS_SIDEBAR_SUCCESS:
			setJESettingsSidebarSuccess(stateClone, action.sidebarIsSuccess)
			break;
		case types.SET_JESETTINGS_SIDEBAR_FORM_VALIDATION_ERROR:
			setJESettingsSidebarFormValidationError(stateClone, action.sidebarFormValidationError)
			break;
		case types.SET_JESETTINGS_SIDEBAR_ERROR:
			setJESettingsSidebarError(stateClone, action.sidebarError)
			break;
	}

	return stateClone;
};


let updateProcessItemStatus = (state: IUpgradeState, key: string, status: string): IUpgradeState => {
	if (state.processList) {
		state.processList[state.tab][key].upgradeStatus = status;;
	}

	return state;
};

let addProcessList = (state: IUpgradeState, item: any): IUpgradeState => {
	item.forEach(row => {
		state.processList[state.tab].push(row);
	});

	return state;
};
let removeProcessList = (state: IUpgradeState, journeyId: any): IUpgradeState => {

	if (journeyId) {
		let getJourneyItem: IJourneyItem = state.processList[state.tab].filter((value: IJourneyItem, index: number) => {
			return value.journeyId == journeyId
		})[0];
		let index: number = state.processList[state.tab].indexOf(getJourneyItem);
		state.processList[state.tab].splice(index, 1);
	}
	return state;
};

let updateIsProcessingState = (state: IUpgradeState, isProccessing: any, proccessingId, journeyNum: number, isUpgradingScreen: Boolean): IUpgradeState => {
	state.isProccessing = isProccessing;
	state.journeyProcessingId = proccessingId;
	state.journeyProcessNum = journeyNum;
	state.isUpgradingScreen = isUpgradingScreen;
	return state;
};



let clearDownProcessListState = (state: IUpgradeState): IUpgradeState => {
	state.processList[state.tab] = [];
	return state;
};

let clearDownState = (state: IUpgradeState): IUpgradeState => {
	state.isProccessing = false;
	state.journeyProcessingId = "";
	state.journeyProcessNum = 0;
	state.isUpgradingScreen = false;
	state.processList[state.tab] = [];
	state.loggingList = [];
	state.UpgradeId = IdHelper.newGuid();
	state.cancelUpgrade = false;

	if (state.tab) {
		let panels: IAdminToolPanel[] = state.panels.filter(item => item.tabName == state.tab)
		if (panels) {
			panels.forEach((panel: IAdminToolPanel) => {
				if (panel.values) {
					let keys: any = Object.keys(panel.values);
					keys.forEach(key => {
						panel.values[keys] = undefined;
					});
				}
			});
		}
	}

	return state;
};
let cancelUpgrade = (state: IUpgradeState, cancelUpgrade: boolean): IUpgradeState => {
	state.cancelUpgrade = cancelUpgrade;
	return state;
};

let updateloggingList = (state: IUpgradeState, updateloggingList: any): IUpgradeState => {
	state.loggingList = updateloggingList;
	return state;
};

let setPageMode = (state: IUpgradeState, mode: string): IUpgradeState => {
	state.pageMode = mode;
	return state;
};
let setTabMode = (state: IUpgradeState, tab: string): IUpgradeState => {
	state.tab = tab;
	return state;
};

let addOrUpdatePanelErrorMessage = (state: IUpgradeState, panelName: string, errorMessage: string): IUpgradeState => {

	let findPanel: IAdminToolPanel = state.panels.filter((a) => {
		return a.panelName === panelName;
	})[0];

	if (findPanel) {
		if (!findPanel.errorMessages) {
			findPanel.errorMessages = [];
		}
		findPanel.errorMessages.push(errorMessage)
	}
	return state;
};

let clearPanelErrorMessages = (state: IUpgradeState, panelName): IUpgradeState => {

	let findPanel: IAdminToolPanel = state.panels.filter((a) => {
		return a.panelName === panelName;
	})[0];

	if (findPanel) {
		findPanel.errorMessages = [];
	}

	return state;
};


let setPanelLoading = (state: IUpgradeState, panelName, isLoading: boolean): IUpgradeState => {

	let findPanel: IAdminToolPanel = state.panels.filter((a) => {
		return a.panelName === panelName;
	})[0];

	if (findPanel) {
		findPanel.isLoading = isLoading;
	}

	return state;
};

let setPagingNumber = (state: IUpgradeState, panelName, pagingNumber: number): IUpgradeState => {

	let findPanel: IAdminToolPanel = state.panels.filter((a) => {
		return a.panelName === panelName;
	})[0];

	if (findPanel) {
		findPanel.listPaging = pagingNumber;
	}

	return state;
};

let setSearchFilters = (state: IUpgradeState, panelName, word: string): IUpgradeState => {

	let findPanel: IAdminToolPanel = state.panels.filter((a) => {
		return a.panelName === panelName;
	})[0];

	if (findPanel) {
		findPanel.searchFilter = word;
	}

	return state;
};

let setPanelValue = (state: IUpgradeState, panelName, valueKey: string, value: string): IUpgradeState => {

	let findPanel: IAdminToolPanel = state.panels.filter((a) => {
		return a.panelName === panelName;
	})[0];

	if (findPanel) {
		if (!findPanel.values) {
			findPanel.values = [];
		}
		findPanel.values[valueKey] = value;
	}

	return state;
};

let addOrUpdatePanel = (state: IUpgradeState, panel: IAdminToolPanel): IUpgradeState => {

	let findThis: IAdminToolPanel = state.panels.filter((a) => {
		return a.panelName === panel.panelName;
	})[0];

	//update
	if (findThis) {
		findThis.values = panel.values;
		findThis.isDisplayed = panel.isDisplayed;
		findThis.errorMessages = panel.errorMessages;
		findThis.searchFilter = panel.searchFilter;
		findThis.listPaging = panel.listPaging;
		findThis.isLoading = panel.isLoading;
	}
	else {
		state.panels.push(panel);
	}
	return state;
};

let setUpgradeSettings = (state: IUpgradeState, version?: string, advancedLogging?: Boolean,) => {
	if (advancedLogging != null) {
		state.advancedLogging = advancedLogging;
	}
	if (version != null) {
		state.adminToolVersion = version;
	}
	return state;
}

let setJESettingsSidebar = (state: IUpgradeState, sidebar?: IJESettingsSidebar) => {
	state.sidebar = sidebar;
	return state;
}

let setJESettingsSidebarProperty = (state: IUpgradeState, key: string, value: any) => {
	if (state.sidebar.jesetting) {
		state.sidebar.jesetting[key] = value
	} else {
		state.sidebar.jesetting = {
			description: "",
			keyField: "",
			nameField: "",
			valueField: ""
		};
		state.sidebar.jesetting[key] = value
	}
	return state;
}
let setJESettingsSidebarJESetting = (state: IUpgradeState, jesetting: JESettingsListData) => {
	state.sidebar.jesetting = jesetting;
	return state;
}
let setJESettingsSidebarSuccess = (state: IUpgradeState, value: boolean) => {
	state.sidebar.isSuccess = value;
	return state;
}

let setJESettingsSidebarFormValidationError = (state: IUpgradeState, value: string[]) => {
	state.sidebar.formValidationError = value;
	return state;
}

let setJESettingsSidebarError = (state: IUpgradeState, value: string) => {
	state.sidebar.error = value;
	return state;
}

export default adminToolReducer;


// WEBPACK FOOTER //
// ./source/ts/store/reducers/admintool.ts